import { useSyncExternalStore } from 'react'

/** Live match for a media query (re-renders when it flips). */
export function useMedia(query: string): boolean {
  return useSyncExternalStore(
    (cb) => {
      const m = window.matchMedia(query)
      m.addEventListener('change', cb)
      return () => m.removeEventListener('change', cb)
    },
    () => window.matchMedia(query).matches,
    () => false,
  )
}

/** Desktop composition starts at 1024px (Astra §2). */
export const useDesktop = () => useMedia('(min-width: 1024px)')

/** The theme actually showing: an explicit choice (html[data-theme]) wins, else the system setting. */
export function useDarkTheme(): boolean {
  const system = useMedia('(prefers-color-scheme: dark)')
  const chosen = useSyncExternalStore(
    (cb) => {
      const mo = new MutationObserver(cb)
      mo.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] })
      return () => mo.disconnect()
    },
    () => document.documentElement.getAttribute('data-theme'),
    () => null,
  )
  return chosen ? chosen === 'dark' : system
}
